import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListGroup, ButtonGroup, ToggleButton } from 'react-bootstrap';
import { useField } from 'formik';
import { Numeric } from '@utils/typescript';

type Props = {
  label: string;
  name: string;
  age: Numeric | '';
};

const MemberItem = ({ label, age, name }: Props) => {
  const { t } = useTranslation();
  const [field, ,] = useField(name);

  return (
    <ListGroup.Item className="text-center">
      <h6 className="m-0">{label}</h6>
      <small className="d-block">
        ({t('user.yearsOld', { age: age })})
      </small>

      <ButtonGroup size="sm">
        <ToggleButton
          {...field}
          type="radio"
          id={`${name}-yes`}
          checked={field.value == 'yes'}
          variant="outline-secondary"
          value="yes"
          onBlur={undefined}
        >
          {t('common:yes')}
        </ToggleButton>

        <ToggleButton
          {...field}
          type="radio"
          id={`${name}-no`}
          checked={field.value == 'no'}
          variant="outline-secondary"
          value="no"
          onBlur={undefined}
        >
          {t('common:no')}
        </ToggleButton>
      </ButtonGroup>
    </ListGroup.Item>
  );
};

export { MemberItem };
